<div class="select-container" [ngClass]="{ active: searchFieldIsActive }">
  @if (label) {
    <label class="paragraph-medium regular korviu-input-label">
      {{ label }}
    </label>
  }
  <nz-select
    nzShowSearch
    nzSize="large"
    class="paragraph-medium"
    nzPlaceHolder=""
    [nzShowArrow]="!serverSearch"
    [nzServerSearch]="serverSearch"
    [(ngModel)]="currentSelectValue"
    [disabled]="disabled"
    (nzFocus)="onFocus()"
    (nzBlur)="onBlur()"
    (ngModelChange)="onSelectModelChange($event)"
    (nzOnSearch)="onSearch($event)"
    [nzDropdownClassName]="'multi-select'"
  >
    @if (!serverSearch) {
      @for (item of options; track item) {
        <nz-option
          class="paragraph-medium"
          [nzLabel]="dropdownLabelFormatFn ? dropdownLabelFormatFn(item) : item?.value"
          [nzValue]="item?.id"
        ></nz-option>
      }
    }
    @if (serverSearch && !searchIsLoading) {
      @for (item of serverOptions; track item) {
        <nz-option
          class="paragraph-medium"
          [nzLabel]="dropdownLabelFormatFn ? dropdownLabelFormatFn(item) : item?.value"
          [nzValue]="item?.id"
        ></nz-option>
      }
    }
    @if (serverSearch && !searchIsLoading && !serverOptions.length) {
      <nz-option nzDisabled nzCustomContent>
        <div class="flex flex-row items-center gap-2">
          <span nz-icon nzType="inbox" nzTheme="outline"></span>
          {{ 'korviuNoData.noData' | translate }}
        </div>
      </nz-option>
    }
    @if (serverSearch && searchIsLoading) {
      <nz-option nzDisabled nzCustomContent>
        <div class="flex flex-row items-center gap-2">
          <span nz-icon [nzType]="'loading'"></span>
          {{ 'common.loading' | translate }}
        </div>
      </nz-option>
    }
  </nz-select>
</div>
<div class="selected-business-values">
  @for (selectedValue of selectedValues; track selectedValue) {
    <div class="business-value-chips">
      <span class="paragraph-medium">{{
        chipsLabelFormatFn ? chipsLabelFormatFn(selectedValue) : selectedValue?.value
      }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        (click)="onBusinessValueDelete(selectedValue)"
      >
        <path
          d="M0.075897 0.156795L0.113378 0.113378C0.250808 -0.0240515 0.465859 -0.0365418 0.617399 0.075897L0.660816 0.113378L4 3.45239L7.3392 0.113378C7.49038 -0.0377909 7.73544 -0.0377909 7.88661 0.113378C8.03779 0.264547 8.03779 0.509647 7.88661 0.660816L4.54762 4L7.88661 7.3392C8.02406 7.4766 8.03655 7.69167 7.92408 7.8432L7.88661 7.88661C7.74922 8.02406 7.53415 8.03655 7.38261 7.92408L7.3392 7.88661L4 4.54762L0.660816 7.88661C0.509647 8.03779 0.264547 8.03779 0.113378 7.88661C-0.0377909 7.73544 -0.0377909 7.49038 0.113378 7.3392L3.45239 4L0.113378 0.660816C-0.0240515 0.523386 -0.0365418 0.308336 0.075897 0.156795Z"
          fill="#787878"
        />
      </svg>
    </div>
  }
</div>
